import script from "./UserRegister.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserRegister.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__